export default __webpack_public_path__ + "static/media/Solomon2.71623c7a.png";